"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_transition_group_1 = require("react-transition-group");
var theme_1 = require("@prezzee/theme");
var utils_1 = require("@prezzee/utils");
var styles = {
    entering: {
        opacity: 1,
    },
    entered: {
        opacity: 1,
    },
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Fade = (0, react_1.forwardRef)(function (props, ref) {
    var theme = (0, theme_1.useTheme)();
    var defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
    };
    var addEndListener = props.addEndListener, _a = props.appear, appear = _a === void 0 ? true : _a, children = props.children, easing = props.easing, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _b = props.timeout, timeout = _b === void 0 ? defaultTimeout : _b, refProp = props.ref, other = __rest(props, ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "ref"]);
    var enableStrictModeCompat = true;
    var nodeRef = (0, react_1.useRef)(null);
    // @ts-ignore
    var foreignRef = (0, utils_1.useForkRef)(children.ref, ref);
    var handleRef = (0, utils_1.useForkRef)(nodeRef, foreignRef);
    var normalizedTransitionCallback = function (callback) { return function (maybeIsAppearing) {
        if (callback) {
            var node = nodeRef.current;
            // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
            if (maybeIsAppearing === undefined) {
                callback(node);
            }
            else {
                callback(node, maybeIsAppearing);
            }
        }
    }; };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
        (0, utils_1.reflow)(node); // So the animation always start from the start.
        var transitionProps = (0, utils_1.getTransitionProps)({ style: style, timeout: timeout, easing: easing }, {
            mode: 'enter',
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) {
            onEnter(node, isAppearing);
        }
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function (node) {
        var transitionProps = (0, utils_1.getTransitionProps)({ style: style, timeout: timeout, easing: easing }, {
            mode: 'exit',
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) {
            onExit(node);
        }
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleAddEndListener = function (next) {
        if (addEndListener && nodeRef.current) {
            // Old call signature before `react-transition-group` implemented `nodeRef`
            addEndListener(nodeRef.current, next);
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.Transition, __assign({ appear: appear, in: inProp, nodeRef: enableStrictModeCompat ? nodeRef : undefined, onEnter: handleEnter, onEntered: handleEntered, onEntering: handleEntering, onExit: handleExit, onExited: handleExited, onExiting: handleExiting, addEndListener: handleAddEndListener, timeout: timeout }, other, { ref: refProp }, { children: function (state, childProps) {
            return (0, react_1.cloneElement)(children, __assign({ style: __assign(__assign(__assign({ opacity: 0, visibility: state === 'exited' && !inProp ? 'hidden' : undefined }, styles[state]), style), children.props.style), ref: handleRef }, childProps));
        } })));
});
exports.default = Fade;
//# sourceMappingURL=Fade.js.map